module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/special_offers/Bitmap2-6804ff7a871dc3b3b6a60c33dc049368.png";